import React, { useState } from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

export default React.memo(({ title, text, textHTML, closeModal }) => {
  const [isOpen, setIsOpen] = useState(true);
  const hideModal = () => {
    setIsOpen(false);
    return closeModal && closeModal();
  };

  return (
    <Modal isOpen={isOpen}>
      {title && <Header>{title}</Header>}
      <Body>
        {text && <ModalContent>{text}</ModalContent>}
        {textHTML && (
          <ModalContent
            dangerouslySetInnerHTML={{
              __html: textHTML,
            }}
          />
        )}
      </Body>
      <Footer>
        <FooterButton label="Close" onClick={hideModal} autoFocus={true} />
      </Footer>
    </Modal>
  );
});
